import React, { useState } from 'react';

import { Box } from '@/presentation/modules/events/modules/eventDetail/components/InPersonEventBox';
import ReusableButton from '@/presentation/reusables/Button';
import { Text } from '@/presentation/components';
import { WaintingListStatus } from '../modules/events/constants';
import { RightSideModal } from '../modules/events/modules/eventDetail/components/RightSideModal';

interface WaitingListBoxesProps {
  event: any;
  onRegisterWaitingList: () => void;
  onLeaveWaitingList: () => void;
}

const WaitingListBoxes: React.FC<WaitingListBoxesProps> = ({
  event,
  onRegisterWaitingList,
  onLeaveWaitingList
}) => {
  const [detailShow, setDetailShow] = useState(false);
  const handleIn = () => setDetailShow(true);
  const handleOut = () => setDetailShow(false);

  const { statusWaitingList, vacancies, isSubscribed } = event;

  return (
    <>
      {!isSubscribed &&
        vacancies === 0 &&
        statusWaitingList === WaintingListStatus.ENABLED_TO_WAITING_LIST && (
          <Box borderColor="#7A959F" style={{ margin: '12px 0' }}>
            <b style={{ marginBottom: 16 }}>{'Lista de espera'}</b>
            <p style={{ marginBottom: 12 }}>
              {event.waitingListDescription ||
                'Este evento no tiene vacantes. Si se libera una, recibirás un correo y contarás con 24 horas para inscribirte.'}{' '}
              <button
                type="button"
                onClick={handleIn}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#5b36f2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                  margin: 0
                }}
              >
                Conoce cómo funciona.
              </button>
            </p>
            <ReusableButton
              text={event.waitingListJoinText || 'Unirme a lista de espera'}
              style={{ padding: '12px 24px' }}
              onClick={onRegisterWaitingList}
              outlined
            />
          </Box>
        )}
      {vacancies === 0 &&
        statusWaitingList === WaintingListStatus.IN_WAITING_LIST && (
          <Box borderColor="#7A959F" style={{ margin: '12px 0' }}>
            <b style={{ marginBottom: 16 }}>{'¡Estás en lista de espera!'}</b>
            <p style={{ marginBottom: 12 }}>
              {event.waitingListInText ||
                'Te avisaremos por correo si se libera una vacante. Tendrás 24 horas para inscribirte.'}
            </p>
            <ReusableButton
              text={event.waitingListLeaveText || 'Salir de la lista de espera'}
              style={{ padding: '12px 24px' }}
              onClick={onLeaveWaitingList}
              outlined
            />
          </Box>
        )}
      {vacancies === 0 &&
        statusWaitingList === WaintingListStatus.ENABLED_TO_REGISTER && (
          <Box borderColor="#7A959F" style={{ margin: '12px 0' }}>
            <b style={{ marginBottom: 16 }}>
              {event.waitingListAvailableTitle || '¡Vacante disponible!'}
            </b>
            <p>
              {event.waitingListAvailableText ||
                'Tienes 24 horas para inscribirte desde que recibiste el correo. Si no lo haces, se te retirará de la lista automáticamente.'}
            </p>
          </Box>
        )}
      {detailShow && (
        <RightSideModal open={detailShow} onClose={handleOut}>
          <Text fontWeight={700} fontSize="20px" lineHeight="32px">
            {event.waitingListModalTitle ||
              '¿Cómo funciona la lista de espera?'}
          </Text>
          {event.waitingListModalContent || (
            <ul style={{ marginLeft: 20, marginTop: 16, color: '#161D1F' }}>
              <li style={{ listStyle: 'initial' }}>
                Cuando un evento se llena, puedes unirte a la lista de espera.
              </li>
              <li style={{ listStyle: 'initial' }}>
                Si alguien anula su inscripción, notificaremos al siguiente.
              </li>
              <li style={{ listStyle: 'initial' }}>
                Te avisaremos hasta un día antes del inicio.
              </li>
            </ul>
          )}
        </RightSideModal>
      )}
    </>
  );
};

export default WaitingListBoxes;
